import React from "react";
import { withStyles } from "@material-ui/core/styles";
import LinearProgress from "@material-ui/core/LinearProgress";

export default withStyles(theme => ({ root: { width: "100%" } }))(
  React.memo(() => <LinearProgress />)
);
